import { SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { ProgettiNode } from '@gql/graphql'
import { useTrans } from '@hooks/index'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { ProgettoCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './ProgettiCorrelatiSection.module.sass'
import useTransRoute from '@hooks/useTransRoute'

interface Props {
  progetti?: ProgettiNode[]
  item?: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const ProgettiCorrelatiSection = (props: Props) => {
  const { progetti = [], item = undefined, theme = undefined, className = '' } = props

  const t = useTrans()
  const tRoute = useTransRoute()

  return progetti?.length ? (
    <GenericSection
      theme={theme}
      item={{
        name: t('Progetti correlati'),
        ctaLabel: t('Vedi tutti i progetti'),
        url: tRoute('/progetti')?.href, // TODO url
        ...item, // Override
      }}
      className={`${styles.root} ${className}`}
    >
      <GenericSlider
        id="progetti-correlati-swiper"
        navigationPos="pagination"
        conf={{
          slidesPerView: 1.1,
          spaceBetween: 20,
          modules: [A11y, Navigation, Pagination],
          navigation: true,
          pagination: { clickable: true },
          breakpoints: {
            768: {
              slidesPerView: 2.2,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        }}
      >
        {progetti.map((i) => (
          <SwiperSlide key={i.slug}>
            <ProgettoCard item={i} />
          </SwiperSlide>
        ))}
      </GenericSlider>
    </GenericSection>
  ) : (
    <></>
  )
}

export default ProgettiCorrelatiSection
